import { getRoles, getRolesSingle } from "./getRoles";

export const RolesApi = {
    getRoles,
    getRolesSingle
}